// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Znim","rootCenter":"LoadMoreObserver_rootCenter__gHruk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2B0Wa"};